import React, { useEffect, useState } from 'react';
import { getAccountSettings } from '../../services/settings';
import './OfferSheet.css';

/** La hoja de oferta que sale de casa (LAKPED-16.4). Lo que se ve es lo que se imprime. */
const euros = (valor) => ((valor || valor === 0)
  ? valor.toLocaleString('es-ES', { style: 'currency', currency: 'EUR' })
  : '—');
const fecha = (valor) => (valor ? new Date(valor).toLocaleDateString('es-ES') : '');

// Número de oferta de cara al cliente: O<año>/<id>, nunca el hash.
export const numeroOferta = (oferta) => {
  if (!oferta?.id) return oferta?.hash ? oferta.hash.slice(0, 8) : '—';
  const anio = new Date(oferta.created || Date.now()).getFullYear().toString().slice(-2);
  return `O${anio}/${String(oferta.id).padStart(4, '0')}`;
};

const OfferSheet = ({ oferta }) => {
  const [logo, setLogo] = useState(null);

  useEffect(() => {
    getAccountSettings()
      .then(s => setLogo(s.logo_url ? `${process.env.REACT_APP_API_URL}${s.logo_url}` : null))
      .catch(() => setLogo(null));
  }, []);

  const lineas = oferta.lines || [];
  const total = lineas.reduce((suma, l) => suma + ((l.unit_price || 0) * (l.quantity || 1)), 0);

  return (
    <div className="offer-pdf-hoja">
      <div className="offer-pdf-cabecera">
        <div className="offer-pdf-titulo">
          <h1>OFERTA</h1>
          <span>Nº {numeroOferta(oferta)} · {fecha(oferta.created)}</span>
        </div>
        {logo && <img src={logo} alt="" className="offer-pdf-logo" />}
      </div>

      <div className="offer-pdf-datos">
        <div><span>Cliente:</span> {oferta.client?.name || '—'}</div>
        {oferta.reference && <div><span>Su referencia:</span> {oferta.reference}</div>}
      </div>

      <table className="offer-pdf-tabla">
        <thead>
          <tr>
            <th>Artículo</th>
            <th>Descripción</th>
            <th className="der">Cant.</th>
            <th className="der">Precio ud.</th>
            <th className="der">Importe</th>
          </tr>
        </thead>
        <tbody>
          {lineas.map((l, i) => (
            <tr key={i}>
              <td>{l.part_code || '—'}</td>
              <td>{l.description || ''}</td>
              <td className="der">{l.quantity ?? 1}</td>
              <td className="der">{euros(l.unit_price)}</td>
              <td className="der">{euros((l.unit_price || 0) * (l.quantity || 1))}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <p className="offer-pdf-total"><b>Total (sin IVA): {euros(total)}</b></p>

      {oferta.notes && <p className="offer-pdf-condiciones">{oferta.notes}</p>}
    </div>
  );
};

export default OfferSheet;
